export const getValidLanguage = (rawLang, supportedLangs, fallbackLang) => {
    if (supportedLangs.includes(rawLang)) {
        return rawLang;
    }
    return fallbackLang;
};
//# sourceMappingURL=i18n.utils.js.map